import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import Amplify from "aws-amplify";
import config from "./config";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./store/store";
import { AuthProvider } from "./authentication/authHelpers";
import { LicenseManager } from "ag-grid-enterprise";
import { initPostHog } from "./analytics/posthogClient";

initPostHog();

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

LicenseManager.setLicenseKey(
  "Using_this_AG_Grid_Enterprise_key_( AG-045792 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Core Scaffold Systems Inc )_is_granted_a_( Single Application )_Developer_License_for_the_application_( Lead Manager )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( Lead Manager )_need_to_be_licensed___( Lead Manager )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 27 July 2024 )____[v2]_MTcyMjAzNDgwMDAwMA==9d9d1a84ee679542095c15b16b4c54e3"
);

const endpointNames = [
  "employees",
  "departments",
  "clocking",
  "employeeRequests",
  "programFields",
  "documentation",
  "hotCredentials",
  "filterTables",
  "docConfiguration",
  "shifts",
  "earnings",
  "deductions",
  "clocking",
  "notifications",
  "userGroups",
  "users",
  "filterTables",
  "clockingLogs",
  "leave",
  "getIp",
  "wages",
  "prepayments",
  "reportsLogs",
  "lazyFetching",
  "employeeOvertime",
  "announcements",
  "interviews",
  "tickets",
  "officeDuties",
  "quoteOfTheDay",
];

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    oauth: {
      domain: "hrtest.auth.us-east-1.amazoncognito.com",
      redirectSignIn: "http://localhost:3000/",
      redirectSignOut: "http://localhost:3000/",
      responseType: "token",
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
    },
  },
  API: {
    endpoints: endpointNames.map((name) => {
      return {
        name: name,
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      };
    }),
  },
});

const root = createRoot(document.getElementById("root"));

root.render(
  <ReduxProvider store={store}>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </ReduxProvider>
);
